module.exports = __webpack_public_path__ + "media/images/signature-white-dbf61ea08e82322efa8050d0d1cf55d9.png";